import React, { useEffect } from "react";
import track, { setPageTitle } from "./utility";
import { Content, Container } from "./elements/layout";
import { ErrorNotification } from "@cb/apricot-react";
import $ from "classnames";
import "./Error.css";
const Error = () => {
  useEffect(() => {
    //TODO: get appId
    setPageTitle("Error");
    //track("500errorpage", appId);
  }, []);

  let DURL = sessionStorage.getItem("DURL");
  if (!DURL) {
    DURL = "";
  }
  //TODO: get appId
  let appId = sessionStorage.getItem("appId");
  if (!appId) {
    appId = "";
  }
  return (
    <Container pageName="iam-error">
      <ErrorNotification title="Errors." style={{ borderRadius: "8px" }}>
        Sorry for the inconvenience but we encountered an <br />
        error within our system. Please try again later.
      </ErrorNotification>
      <Content>
        <a
          className={$(
            "cb-btn",
            "cb-btn-primary",
            "cb-margin-top-48",
            "cb-margin-bottom-32",
            "cb-width-100"
          )}
          href={`${window.appConfig.baseUrl}/login/login?appId=${appId}&DURL=${DURL}`}
        >
          Sign In
        </a>
      </Content>
    </Container>
  );
};

export default Error;
